(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('postcode', function(postcodeService, globalisationService) {
    return {
        restrict: 'E',
        replace: true,
        priority: 100,
        scope: {
            address: '=',
            form: '=',
            isReadonly: '=',
            isPostcodeRequired: '=',
            dontCaptureAddress: '='
        },
        templateUrl(element, attr) {
            if (attr.templateVersion) {
                return `partials/booking/template?name=Postcode&version=${attr.templateVersion}`;
            } else if (attr.templateUrl) {
                return `partials/home/directivetemplate?type=${attr.templateUrl}`;
            }
            return 'partials/home/directivetemplate?type=Postcode';
        },
        link(scope) {
            postcodeService.setKey(scope.key);
            scope.isLookupEnabled = TRPCONFIG.Domain.IsPostcodeLookupEnabled;
            scope.showSearch = TRPCONFIG.Domain.IsPostcodeLookupEnabled;

            if (scope.address && !scope.address.CountryCode) {
                scope.address.CountryCode = TRPCONFIG.Domain.CountryCode;
            }

            function foundAndBound(data) {
                scope.results = data.Items;
            }

            function Appender(base) {
                this.Result = base;
            }

            Appender.prototype.append = function(str) {
                return str ? new Appender(`${this.Result}, ${str}`) : this;
            };

            function retrievedAndBound(data) {
                const detail = data.Items[0];
                scope.results = [];
                scope.address.PostCode = detail.PostalCode;
                scope.address.Address = new Appender(detail.Line1).append(detail.Line2).append(detail.Line3).Result;
                if (detail.Company) {
                    scope.address.Address = `${detail.Company} ${scope.address.Address}`;
                }
                scope.address.City = detail.City;
                scope.showSearch = false;
            }

            scope.next = function(item) {
                if (item.Type !== 'Address') {
                    postcodeService.find(item.Text, scope.address.CountryCode, item.Id).then(foundAndBound);
                } else if (item.Type === 'Address') {
                    postcodeService.retrieve(item.Id).then(retrievedAndBound);
                }
            };

            scope.resetAddress = function(isSearchVisible) {
                scope.showSearch = isSearchVisible;
                scope.address.PostCode = '';
                scope.address.Address = '';
                scope.address.City = '';
                scope.address.County = '';
            };

            scope.findAddress = val => {
                if (val && val.length >= 2) {
                    postcodeService.find(val, scope.address.CountryCode).then(foundAndBound);
                }
            };

            scope.$on('auth:signout', () => scope.showSearch = TRPCONFIG.Domain.IsPostcodeLookupEnabled);

            scope.$on('form:submitted-invalid', function(event, form) {
                // ensuring that we are only setting showSearch on the correct form when there are multiple forms on page
                if (form && scope.form && form.$name !== scope.form.$name) { return; }
                if (scope.addressForm.$invalid) {
                    scope.showSearch = false;
                }
            });

            scope.$watch('address.CountryCode', function() {
                if (TRPCONFIG.Domain.FilterCountryList) {
                    scope.countries = filterCountries();
                }
                scope.results = [];
                if (TRPCONFIG.Domain.EnableContactState && scope.address && scope.address.CountryCode) {
                    globalisationService.getStates(scope.address.CountryCode).then(s => {
                        scope.states = s;
                    });
                }
            });

            scope.$watch('address', function(value) {
                if (value &&
                    (value.PostCode ||
                        value.Address ||
                        value.City ||
                        value.County)) {
                    scope.showSearch = false;
                }
            }, true);

            function filterCountries() {
                const countryCodesArr = TRPCONFIG.Domain.FilterCountryList.split(',').map(function(el) {
                    return el.trim();
                });
                let filteredCountries = scope.countries.filter(function(country) {
                    return countryCodesArr.includes(country.Code);
                });
                return filteredCountries;
            }
        }
    };
});
})();
